var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconFillFolder = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66667 2.5C2.47005 2.5 1.5 3.47005 1.5 4.66667V15.0141C1.5 16.0188 2.3145 16.8333 3.31923 16.8333H15.7035C16.8075 16.8333 17.735 16.0032 17.8569 14.9059L18.3199 10.7393C18.3879 10.1267 18.1919 9.51422 17.7809 9.055C17.6946 8.95856 17.6005 8.87079 17.5 8.79231V7.16667C17.5 5.97005 16.53 5 15.3333 5H9.975C9.86466 5 9.76148 4.9454 9.69941 4.85417L9.6994 4.85417L8.49456 3.08336L8.49454 3.08333C8.24627 2.71841 7.8335 2.5 7.39213 2.5H3.66667ZM16.1665 8.33333C16.2789 8.33333 16.3904 8.34207 16.5 8.35915V7.16667C16.5 6.52233 15.9777 6 15.3333 6H9.975C9.53365 6 9.12089 5.78159 8.87262 5.41669L7.66776 3.64587L7.66774 3.64584C7.60568 3.55461 7.50248 3.5 7.39213 3.5H3.66667C3.02233 3.5 2.5 4.02233 2.5 4.66667V15.0141C2.5 15.4665 2.86678 15.8333 3.31923 15.8333C3.73667 15.8333 4.08735 15.5195 4.13345 15.1046L4.67166 10.2607C4.79358 9.16346 5.72105 8.33333 6.82508 8.33333H16.1665Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconFillFolder);
export default ForwardRef;